module.exports = __webpack_public_path__ + "img/preloader.bb9bb073.svg";